module.exports = __webpack_public_path__ + "img/notes.5e44e4a.svg";